import { call, put, takeEvery } from 'redux-saga/effects';
import { authActionCreators } from '..';
import { authService } from '../../..';
import { coreActionCreators } from '../../core';

function* login(action: ReturnType<typeof authActionCreators.login>) {
  yield put(authActionCreators.toggleLoggingIn());

  const idToken = yield call(async () => authService.openLoginPopup());

  if (idToken) {
    yield put(coreActionCreators.initApp());
  }
  yield put(authActionCreators.toggleLoggingIn());
}

export function* watchLogin() {
  yield takeEvery(authActionCreators.login.match, login);
}
